import httpClient from './httpClient'

const END_POINT = '/api/personas'

const getAllPersonas = () => httpClient.get(END_POINT)

const checkPersona = (dni) => httpClient.get(END_POINT, { params: { dni: dni } } )

const checkPersonaReferencia = (codigo) => httpClient.get(`${END_POINT}/${codigo}`)

const postPersona = (data) => httpClient.post(END_POINT, data)

const putPersona = (id,data) => httpClient.put(`${END_POINT}/${id}`, data)

export {

    getAllPersonas,
    checkPersona,
    checkPersonaReferencia,
    postPersona,
    putPersona

}